import React from "react";
import { Link } from 'react-router-dom'
import ScrollToTop from './scroll';

const Footer = () => {
    return (
        <div className="font-[Roboto Sans] relative bottom-0 w-full">
            <ScrollToTop />
            <div className="bg-slate pl-4 p-6 text-[0.8em] relative flex flex-col lg:flex-row text-left justify-between lg:items-center">
                <div className="flex flex-row justify-between lg:flex-col">
                    <h1 className="uppercase font-semibold pl-4"><span className="text-navy tracking-spaced">Al</span><span className="text-ocean tracking-spaced">kor</span></h1>
                    <p className="hidden lg:block lg:mt-4 pl-4">© Copyright 2025</p>
                </div>

                <div className="pl-4 lg:mt-0 lg:pl-0 text-left lg:text-right">
                    <p className="hidden lg:block font-medium uppercase font-[600]">Resources</p>
                    <ul className="mt-4">
                        <li className="mb-2"><Link className="hover:text-ocean" to="/contact">Contact Us</Link></li>
                        <li><Link className="hover:text-ocean" to="/terms">Terms and Conditions</Link></li>
                    </ul>
                </div>

                <p className="lg:hidden block pl-4 pt-4">© Copyright 2025</p>
            </div>
        </div>
    );
};

export default Footer;




